function easeInOutQuad(t: number, b: number, c: number, d: number) {
  t /= d / 2;
  if (t < 1) {
    return (c / 2) * t * t + b;
  }
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
}

export function isSmoothScrollSupported() {
  return getComputedStyle(document.body).scrollBehavior;
}

export function scrollToPosition({
  element,
  position,
  duration = 400,
  direction = 'horizontal',
}: {
  element: HTMLElement;
  position: number;
  duration?: number;
  direction?: 'horizontal' | 'vertical';
}) {
  const start =
    direction === 'vertical' ? element.scrollTop : element.scrollLeft;
  const to = position;
  const change = to - start;
  const increment = 20;
  let currentTime = 0;
  const animateScroll = function () {
    currentTime += increment;
    const val = easeInOutQuad(currentTime, start, change, duration);
    if (direction === 'vertical') {
      element.scrollTop = val;
    } else {
      element.scrollLeft = val;
    }
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    }
  };

  if (duration > 0) {
    window.requestAnimationFrame(animateScroll);
  } else {
    if (direction === 'vertical') {
      element.scrollTop = to;
    } else {
      element.scrollLeft = to;
    }
  }
}
